import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AiStatusService } from '../../../services/index';

@Component({
    selector: 'add-edit-ai-status',
    templateUrl: './addEditAiStatus.component.html'
})
export class AddEditAiStatusComponent implements OnInit {
    public title: string;
    public aiStatusData: any = {};
    isLoading = false;
    statusList = ['Active', 'Inactive'];

    @Output() loadEvent = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private aiStatusService: AiStatusService
    ) {}

    ngOnInit() {
        if (!this.aiStatusData.status) {
            this.aiStatusData.status = 'Active';
        }
    }

    onSave() {
        this.isLoading = true;
        this.aiStatusService.save(this.aiStatusData).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');
                this.bsModalRef.hide();
                this.loadEvent.emit();
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiStatus/addEditAiStatus.component.ts